import { openDB, executeTx } from '../database/db';
import { dateUtils } from '../utils/dateUtils';

export const fileRepository = {
  saveFile: async (projectId, fileBlob, metadata = {}) => {
    const fileRecord = {
      id: 'file-' + dateUtils.now() + '-' + Math.random().toString(36).substr(2, 4),
      projectId,
      recordId: metadata.recordId || null,
      type: metadata.type || 'general', // 'crack-image' | 'ocr-scan' | 'pdf'
      name: metadata.name || 'attachment',
      size: fileBlob.size,
      mimeType: fileBlob.type,
      blob: fileBlob,
      timestamp: dateUtils.now()
    };

    await executeTx('files', 'readwrite', (tx) => {
      tx.objectStore('files').put(fileRecord);
    });
    return fileRecord;
  },

  getByProject: async (projectId, type = null) => {
    const db = await openDB();
    return new Promise((resolve) => {
      const tx = db.transaction('files', 'readonly');
      const store = tx.objectStore('files');
      const index = store.index('projectId');
      const req = index.getAll(projectId);
      req.onsuccess = () => {
        let results = req.result || [];
        if (type) results = results.filter((f) => f.type === type);
        results.sort((a, b) => b.timestamp - a.timestamp);
        resolve(results);
      };
    });
  },

  delete: async (fileId) => {
    await executeTx('files', 'readwrite', (tx) => {
      tx.objectStore('files').delete(fileId);
    });
    return true;
  }
};
